/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 08/12/2024 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Protección anti doble click en acciones críticas
*      3       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Corrección de acciones de entrega e impresión
*      4       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Corrección de tooltips en acciones deshabilitadas
*      5       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Menú de mantenimiento de cuentas
*      6       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Etiquetas claras para abono y reimpresión
*      7       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Reimpresión de abonos trasladada a otras acciones
*      8       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Trazas de depuración en entrega definitiva
*      9       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Menú de otras acciones controlado desde el formulario
*      10      | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Bloqueo de otras acciones hasta cargar apartado
*      11      | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Estándar visual de botones bloqueados
* ---------------------------------------------------------------------------------------
*/

import { Fragment } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import PrintIcon from '@mui/icons-material/Print';
import HomeIcon from '@mui/icons-material/Home';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import MenuIcon from '@mui/icons-material/Menu';

import { useVentas } from "../../context/Ventas/VentasContext";
import { useDoubleClickPrevention } from '../../hooks/useDoubleClickPrevention';

const ActionTooltip = ({ title, children }) => (
    <Tooltip title={title}>
        <span style={{ display: 'inline-flex' }}>
            {children}
        </span>
    </Tooltip>
);

export default function MnuApartadosActions({ onOpenOtherActions }) {
const { isProcessing, executeWithProtection } = useDoubleClickPrevention();
const {
        statusCobroApartado = false,
        statusActualApartado = false,
        dataEstadoCuentaApartado = {},
        handleClickRegresarMainDashboard,
        handleAbrirModalGenerarAbonoApartados,
        handleAbrirModalEntregaDefinitiva,
        handleClickEstadoCuentaCliente, 
        handleAbrirModalCambioCostoApartados,
        handleAbrirModalCancelarApartados,
    } = useVentas();
    
    const hasApartadoData = dataEstadoCuentaApartado?.apartados?.length > 0;
    
    return (
        <Fragment>
            <ActionTooltip title={"Home"}>
                <IconButton onClick={handleClickRegresarMainDashboard}>
                    <HomeIcon className="icon" /><p className="icon"> Salir</p>
                </IconButton>
            </ActionTooltip>
            
            <ActionTooltip title={"Nuevo abono"}>
                <IconButton 
                    onClick={handleAbrirModalGenerarAbonoApartados} 
                    disabled={isProcessing || !statusCobroApartado}
                >
                    <AddIcon className="icon" />
                    <p className="icon">Nuevo abono</p>
                </IconButton>
            </ActionTooltip>


            <ActionTooltip title={"Aplicar descuento"}>
                <IconButton 
                    onClick={() => executeWithProtection(handleAbrirModalCambioCostoApartados)} 
                    disabled={isProcessing || !statusActualApartado}
                >
                    <EditIcon className="icon" />
                    <p className="icon">Aplicar desc.</p>
                </IconButton>
            </ActionTooltip>
           
            <ActionTooltip title={"Cancelar apartado"}>
                <IconButton 
                    onClick={() => executeWithProtection(handleAbrirModalCancelarApartados)} 
                    disabled={isProcessing || !statusActualApartado}
                >
                    <CloseIcon className="icon" />
                    <p className="icon">Cancelar</p>
                </IconButton>
            </ActionTooltip>

            <ActionTooltip title={"Entrega definitiva"}>
                <IconButton 
                    onClick={() => executeWithProtection(() => {
                        if (!hasApartadoData) {
                            console.warn("[Apartados][EntregaDefinitiva][ClickSinApartado]", {
                                dataEstadoCuentaApartado
                            });
                            return;
                        }
                        const apartado = dataEstadoCuentaApartado.apartados[0];
                        const totalAbonado = dataEstadoCuentaApartado.totalabonado || 0;
                        const montoRestante = apartado.costoarticulo - totalAbonado;
                        return handleAbrirModalEntregaDefinitiva(montoRestante);
                    })} 
                    disabled={isProcessing || !statusActualApartado}
                >
                    <LocalShippingIcon className="icon" />
                    <p className="icon">Entrega definitiva</p>
                </IconButton>
            </ActionTooltip>
            
            <ActionTooltip title="Imprimir estado cuenta">
                <IconButton onClick={() => executeWithProtection(handleClickEstadoCuentaCliente)} disabled={isProcessing || !hasApartadoData}>
                    <PrintIcon className="icon" /><p className="icon">Estado cuenta</p>
                </IconButton>
            </ActionTooltip>

            <ActionTooltip title="Más acciones">
                <IconButton onClick={onOpenOtherActions} disabled={isProcessing || !hasApartadoData}>
                    <MenuIcon className="icon" /><p className="icon">Menu</p>
                </IconButton>
            </ActionTooltip>
        </Fragment>
    );
}
